import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-方向2",
  "use": "icon-方向2-usage",
  "viewBox": "0 0 192 96",
  "content": "<symbol viewBox=\"0 0 192 96\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-方向2\">\n    <title>icon/10pt/方向2</title>\n    <g id=\"icon-方向2_icon/10pt/方向2\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <line x1=\"175.86039\" y1=\"47.4142136\" x2=\"11.6532829\" y2=\"47.6396103\" id=\"icon-方向2_路径-2备份\" stroke=\"#2C2C2E\" stroke-width=\"10\" stroke-linejoin=\"round\" />\n        <polyline id=\"icon-方向2_路径备份-2\" stroke=\"#2C2C2E\" stroke-width=\"10\" transform=\"translate(153.973088, 47.819805) rotate(-315.000000) translate(-153.973088, -47.819805) \" points=\"131.473088 25.3198052 167.744924 33.0860287 176.473088 70.3198052\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/方向2.svg
// module id = 8Err
// module chunks = 2